import $ from 'jquery';

export default class OfferMainTitle {
  constructor($scope, $rootScope, OfferService, UserService) {
    $scope.set_supplier_autocomplete = function(input) {
      input.autocomplete({
        delay: 300,
        source: function(request, response) {
          UserService.search_by_company('Seller', request.term).then(function(data) {
            response(data.users);
          });
        },
        select: function(event, ui) {
          $scope.offer.supplier_id = ui.item.id;
          $scope.offer.user_contact_id = null;
          $scope.supplier_company = ui.item.value;
          $scope.$apply();
          $scope.update_supplier_data(ui.item.id);
        }
      });
    };

    $scope.update_supplier_data = function(user_id) {
      UserService.get_contacts(user_id).success(function(data) {
        $scope.supplier_contacts = data.contacts;
      });
    };

    $scope.set_title_data = function() {
      var count = 0;
      if ($scope.offer.supplier_offer_id)
        count++;
      if ($scope.offer.published_at)
        count++;
      if ($scope.offer.titleEN)
        count++;
      if ($scope.offer.supplier_id)
        count++;
      if ($scope.offer.user_contact_id)
        count++;
      if ($scope.offer.offer_type)
        count++;
      if ($scope.offer.quality)
        count++;
      if ($scope.offer.short_description)
        count++;
      if ($scope.offer.bid_type)
        count++;
      var percentage = Math.floor(count / 9 * 100.0);
      $rootScope.$broadcast('set_sidebar_data', [1, 0, [{
        type: 'percentage',
        value: percentage
      }, null]]);
    };

    $scope.update_offer = function() {
      $scope.updating = true;
      if (!$scope.offer.supplier_id) {
        $scope.form_error = 'Please select a supplier!';
        $scope.updating = false;
      } else if (!$scope.offer.titleEN) {
        $scope.form_error = 'Please insert a Title (Megaepsilon)!';
        $scope.updating = false;
      } else {
        $scope.form_error = '';
        OfferService.save($scope.offer).then(function(data) {
          if (!data.success)
            $scope.form_error = data.message;
          else
            $scope.set_title_data();
          $scope.updating = false;
        });
      }
    };

    $scope.date_options = {
      changeMonth: true,
      changeYear: true,
      dateFormat: 'dd/mm/yy'
    };

    $scope.init = function() {
      $scope.offer_types = window.offer_types;
      $scope.offer_qualities = window.offer_qualities;
      $scope.transaction_types = window.transaction_types;
      $scope.bid_types = window.bid_types;
      $scope.short_descriptions = window.short_descriptions;
      $scope.offer = window.offer;
      $scope.supplier_company = window.supplier_company;
      $scope.update_supplier_data(window.offer.supplier_id);
      $scope.set_supplier_autocomplete($('input.supplier_company'));
    };

    $scope.init();
  }
}

OfferMainTitle.$inject = ['$scope', '$rootScope', 'OfferService', 'UserService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/offer-main-title.ctrl.js